export default "__VITE_ASSET__D$SCnPS2__"